import { Component, Input, inject } from '@angular/core';
import { SiteState } from '@next/core-lib/site';
import { UserSelectors } from '@next/core-lib/user';
import { select, Store } from '@ngrx/store';
import { selectLoggedInEmployee } from 'src/app/store/selectors';

@Component({
  selector: 'app-general-info',
  templateUrl: './general-info.component.html',
  styleUrls: ['./general-info.component.scss'],
  standalone: false,
})
export class GeneralInfoComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  @Input() reportForLabel = 'reportFor';
  loggedInEmployee$ = this.store.pipe(select(selectLoggedInEmployee));
  customer$ = this.store.pipe(select(UserSelectors.selectCustomer));
  location$ = this.store.pipe(select(UserSelectors.selectLocation));
}
